// Role groups, same as App.jsx.
const ISAFE_ROLES = [
  "isafe_accountant",
  "isafe_moderator",
  "isafe_salesperson",
  "isafe_admin",
  "root",
];
const SUBSCRIPTION_ROLES = [
  "subscription_access",
  "subscription_accountant",
  "subscription_admin",
  "subscription_implementor",
  "subscription_salesperson",
];

const ROLE_LABELS = {
  root: "Root",
  isafe_admin: "ISAFE Admin",
  isafe_accountant: "ISAFE Accountant",
  isafe_moderator: "ISAFE Moderator",
  isafe_salesperson: "ISAFE Salesperson",
  subscription_admin: "Subscription Admin",
  subscription_access: "Subscription Access",
  subscription_accountant: "Subscription Accountant",
  subscription_implementor: "Subscription Implementor",
  subscription_salesperson: "Subscription Salesperson",
  subscription_teacher: "Teacher",
};

const roleIds = (roles) =>
  (Array.isArray(roles) ? roles : [])
    .map((role) => (typeof role === "object" ? role?.id ?? role?.role ?? role?.name : role))
    .map(String);

/**
 * Where "Go to …" sends a signed-in user: Admin Central for ISAFE and
 * subscription staff, My Info for everyone else.
 */
export const homeFor = (roles) => {
  const ids = roleIds(roles);
  const isAdmin = ids.some((id) => ISAFE_ROLES.includes(id) || SUBSCRIPTION_ROLES.includes(id));
  return isAdmin
    ? { path: "/admincentral/dashboard", label: "Admin Central" }
    : { path: "/myinfo", label: "My Info" };
};

export const readableRoles = (roles) => {
  const labels = roleIds(roles)
    .map((id) => ROLE_LABELS[id])
    .filter(Boolean);
  return labels.length ? Array.from(new Set(labels)).join(", ") : "No ISAFE role";
};
